import React from "react";
import { POOL_NIGHT } from "@/constants/media";
import { Reveal } from "@/components/brand";

export function PageHero({ eyebrow, title, subtitle, image = POOL_NIGHT, compact = false }) {
  return (
    <section className={`relative ${compact ? "h-[46vh] min-h-[340px]" : "h-[58vh] min-h-[420px]"} overflow-hidden noise`}>
      <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-b from-ink/80 via-ink/50 to-ink" />
      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-6 pt-20">
        <Reveal>
          {eyebrow && <p className="text-xs tracking-label uppercase text-pool mb-4 text-glow-pool">{eyebrow}</p>}
          <h1 className="font-serif text-4xl sm:text-6xl text-foreground">{title}</h1>
          {subtitle && <p className="mt-5 text-muted-foreground max-w-xl mx-auto">{subtitle}</p>}
        </Reveal>
      </div>
    </section>
  );
}

export function Loading({ label = "Loading" }) {
  return (
    <div className="flex items-center justify-center py-24 text-muted-foreground gap-3" data-testid="loading">
      <div className="h-2 w-2 rounded-full bg-gold animate-pulse" />
      <span className="text-sm tracking-label uppercase">{label}</span>
    </div>
  );
}

export function Empty({ title = "Nothing here yet", text }) {
  return (
    <div className="text-center py-20 glass rounded-lg" data-testid="empty-state">
      <h3 className="font-serif text-2xl text-foreground/80">{title}</h3>
      {text && <p className="text-sm text-muted-foreground mt-2 max-w-md mx-auto">{text}</p>}
    </div>
  );
}

export function Field({ label, children, hint, required }) {
  return (
    <label className="block">
      <span className="text-xs tracking-label uppercase text-muted-foreground">{label}{required && <span className="text-gold"> *</span>}</span>
      <div className="mt-1.5">{children}</div>
      {hint && <span className="text-[11px] text-muted-foreground/70 mt-1 block">{hint}</span>}
    </label>
  );
}
